import { styled, Typography } from '@mui/material';
import { alpha } from '@mui/system';
import { capitalizeAndKeepTheRest } from 'helpers/helpers';

type Props = {
    label: string;
    isSelected: boolean;
    isDirectMatch: boolean;
};

const StyTypography = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'isDirectMatch',
})<{ isDirectMatch: boolean }>(({ theme, isDirectMatch }) => ({
    ...(isDirectMatch && {
        backgroundColor: alpha(theme.palette.primary.main, 0.12),
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5),
        borderRadius: theme.spacing(0.5),
    }),
}));

const StyHighlightableLabel = ({ label, isSelected, isDirectMatch }: Props) => (
    <StyTypography
        variant={isSelected ? 'body1SemiBold' : 'body1'}
        color={isSelected ? 'primary.main' : 'text.primary'}
        isDirectMatch={isDirectMatch}
    >
        {capitalizeAndKeepTheRest(label)}
    </StyTypography>
);

export default StyHighlightableLabel;
